import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogImage?: string;
  schema?: Record<string, unknown>;
}

export default function SEO({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = 'website',
  ogImage,
  schema,
}: SEOProps) {
  const location = useLocation();
  const baseUrl = 'http://moonr.cn/';
  const currentUrl = `${baseUrl}${location.pathname}`;

  useEffect(() => {
    const defaultTitle = '51吃瓜黑料 | 51吃瓜黑料网 网曝门与爆料入口全收录 网红猛料不打烊实时更新';
    const defaultDesc = '51吃瓜黑料网站🔥承接网曝门与在线爆料搜索需求，提供入口一二三、每日大赛及视频不打烊，⏰网红猛料实时追踪不停更。';
    const defaultKeywords = '51吃瓜黑料网, 51吃瓜黑料网曝门, 51吃瓜黑料入口, 51吃瓜黑料爆料, 51吃瓜黑料不打烊, 51吃瓜黑料在线, 吃瓜, 黑料, 每日大赛, 视频更新';

    if (typeof document === 'undefined') {
      return null;
    }

    document.title = title || defaultTitle;

    const setMeta = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', description || defaultDesc);
    setMeta('keywords', keywords || defaultKeywords);

    const canonical = canonicalUrl || currentUrl;
    let linkEl = document.querySelector('link[rel="canonical"]');
    if (!linkEl) {
      linkEl = document.createElement('link');
      linkEl.setAttribute('rel', 'canonical');
      document.head.appendChild(linkEl);
    }
    linkEl.setAttribute('href', canonical);

    setMeta('og:title', ogTitle || title || defaultTitle, true);
    setMeta('og:description', ogDescription || description || defaultDesc, true);
    setMeta('og:type', ogType, true);
    setMeta('og:url', canonical, true);
    setMeta('og:locale', 'zh_CN', true);
    setMeta('og:site_name', '51吃瓜黑料网', true);
    if (ogImage) {
      setMeta('og:image', ogImage, true);
    }

    setMeta('twitter:card', 'summary_large_image');
    setMeta('twitter:title', ogTitle || title || defaultTitle);
    setMeta('twitter:description', ogDescription || description || defaultDesc);

    if (schema) {
      let scriptEl = document.querySelector('script[type="application/ld+json"][data-seo]');
      if (!scriptEl) {
        scriptEl = document.createElement('script');
        scriptEl.setAttribute('type', 'application/ld+json');
        scriptEl.setAttribute('data-seo', 'true');
        document.head.appendChild(scriptEl);
      }
      scriptEl.textContent = JSON.stringify(schema);
    }

    return () => {
      const seoScript = document.querySelector('script[type="application/ld+json"][data-seo]');
      if (seoScript) seoScript.remove();
    };
  }, [title, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogImage, schema, currentUrl]);

  return null;
}